<template>
  <div id="login">
    <div class="login-page err-500">
      <div class="container">
        <div class="login-container">
          <div class="row">
            <div class="col-lg-4 col-md-5 col-sm-9 lfh">
              <div class="card login-box">
                <div class="card-body">
                  <loading :active.sync="isLoading" 
                  :can-cancel="true" 
                  :is-full-page="fullPage"></loading>
                  <h5 class="card-title">Sign In</h5>
                  <form @keyup.enter="login(e)">
                    <p v-if="errors.length">
                      <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                    </p>
                    <p style="color:red">{{ errorMessage }}</p>
                    <div class="form-group">
                      <input type="email" class="form-control" name="email" ref="email" v-model="input.email"  id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter email" tabindex="1" spellcheck="false" autofocus />
                    </div>
                    <div class="form-group">
                      <input type="password" name="password" ref="password" v-model="input.password" placeholder="Password"  class="form-control" id="exampleInputPassword1" tabindex="2" />
                    </div>
                    <a href='/forgotpassword' class="float-left forgot-link">Forgot password?</a>
                    <button type="button" class="btn btn-primary m-l-xxs float-right" v-on:click="login(e)">Login</button>
                    <a href="/freeSignup" class="btn btn-secondary float-right">Sign Up</a>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import axios from 'axios'
   import Loading from 'vue-loading-overlay'
   import 'vue-loading-overlay/dist/vue-loading.css'
   export default {
     name: 'Login',
     components: {
       Loading
     },
     data () {
       return {
         isLoading: false,
         fullPage: true,
         errors: [],
         errorMessage: '',
         input: {
           email: '',
           password: '',
           rememberme: ''
         }
       }
     },
     methods: {
       login (e) {
         this.errors = []
         var x = this.input.email
         var atposition = x.indexOf('@')
         var dotposition = x.lastIndexOf('.')
         if (this.input.email === '') {
           this.errors.push('Email is Required')
           this.$refs.email.focus()
         } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
           this.errors.push('Please enter a valid e-mail address ')
           this.$refs.email.focus()
         } else if (this.input.password === '') {
           this.errors.push('Password is Required')
           this.$refs.password.focus()
         } else {
           var email = this.input.email
           var password = this.input.password
           this.isLoading = true
           axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/login',
             {
               email: email,
               password: password
             })
             .then(response => {
               this.isLoading = false
               this.errorMessage = response.data.message
               var role = response.data.results[0].role
               var username = response.data.results[0].name
               var useremail = response.data.results[0].email
               localStorage.setItem('profileimage', response.data.results[0].profile_image)
               localStorage.setItem('uid', response.data.results[0].uid)
               localStorage.setItem('user', JSON.stringify(response.data.results[0]))
               localStorage.setItem('jwt', response.data.results[0].token)
               if (localStorage.getItem('jwt') !== 'undefined' || localStorage.getItem('jwt') !== null) {
                 if (role === 'admin') {
                   // this.$router.push('/admindashboard')
                   window.location = '/admindashboard'
                   localStorage.setItem('role', 'admin')
                   localStorage.setItem('username', username)
                   localStorage.setItem('useremail', useremail)
                 } else {
                   window.location = '/userdashboard'
                   localStorage.setItem('role', 'user')
                   localStorage.setItem('username', username)
                   localStorage.setItem('useremail', useremail)
                 }
               }
             })
             .catch((error) => {
                 this.errorMessage = error.response.data.errors
                 this.isLoading = false
               
             })
         }
       },
       rememberme (e) {
         var checkBox = document.getElementById('rememberme')
         if (checkBox.checked === true) {
           localStorage.usrname = document.getElementById('exampleInputEmail').value
           console.log(localStorage.usrname)
           localStorage.pass = document.getElementById('exampleInputPassword1').value
           localStorage.chkbx = document.getElementById('rememberme').value
         } else {
           localStorage.usrname = ''
           localStorage.pass = ''
           localStorage.chkbx = ''
         }
       }
     },
     mounted () {
       console.log(document.getElementById('exampleInputEmail').value)
       if (localStorage.chkbx && localStorage.chkbx !== '') {
         document.getElementById('rememberme').checked = true
         document.getElementById('exampleInputEmail').value = localStorage.usrname
         document.getElementById('exampleInputPassword1').value = localStorage.pass
       } else {
         document.getElementById('rememberme').checked = false
         document.getElementById('exampleInputEmail').value = ''
         document.getElementById('exampleInputPassword1').value = ''
       }
     }
   }
</script>
                      


// WEBPACK FOOTER //
// src/components/Login.vue